<template>
    <div class="publishhouse" style="width:800px">
        <form class="form_item">
            <el-row class="step_item">
                <label class="label_title">房源特色:</label>
                <el-checkbox-group v-model="housefeaturs" class="furnishings" @change="featureChange">
                    <el-checkbox 
                        v-for="item in FeaturesOptions" 
                        :label="item.KeyWors" 
                        :key="item.ID" 
                        :value="item.ID">{{item.KeyWors}}</el-checkbox>
                </el-checkbox-group>
            </el-row>
            <el-row class="step_item">
                <label class="label_title">周边配套:</label>
                <el-checkbox-group v-model="housepackage" class="furnishings"  @change="packageChange">
                    <el-checkbox 
                        v-for="item in PackageOption" 
                        :label="item.KeyWors" 
                        :key="item.ID" 
                        :value="item.ID">{{item.KeyWors}}</el-checkbox>
                </el-checkbox-group>
            </el-row>
        </form>
    </div>
    
</template>

<script>
export default {
    data(){
        return {
            secondObj:{
                 TypeIds1: []
            },
            housefeaturs: [],
            housepackage:[],
            FeaturesOptions: [],
            PackageOption: []
        }
    },
    props:['houseMessage'],
    methods:{
        gethouseFeatures(){
            //装修
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties',oper:'property_features'},data => {
                this.FeaturesOptions = data
            },err => {

            })
        },
        gethousePackage(){
            //装修
            this.$get('/Handler/FYGL.ashx',{action:'GetHouseProperties',oper:'peripheral_package'},data => {
                this.PackageOption = data
            },err => {
 
            })
        },
        featureChange(val){
            //房源特色ID-FID
            
        },
        packageChange(val){
            //周边配套ID-FID
            
        }
    },
    created(){
         this.gethouseFeatures();
         this.gethousePackage();
    }
}
</script>

<style>
    .publishhouse .step_title{
        color: #278bdd;
        font-size: 14px;
        padding: 25px;
    }
    .publishhouse .boots span{
        display: inline-block;
        width: 70px;
        height: 30px;
        line-height: 30px;
        color: #333;
        font-size: 14px;
        background: #278bdd; 
        text-align: center;
        border-radius: 5px;
        cursor: pointer;
    }
    .publishhouse .boots span.previous_step{
        background: #fff;
        margin-right: 80px;
    }
    .publishhouse .boots span.next_step,
    .publishhouse .boots span.creat_house{
        color: #fff;
    }
    .publishhouse .step_item{
        margin-bottom: 20px;
        font-size: 14px;
        border-bottom: 1px dashed #efefef;
        padding-bottom: 20px;
        position: relative;
    }
    .publishhouse .step_item label.label_title{
        text-align: right;
        padding-right: 8px;
        min-width: 70px;
        display: inline-block;
    }
    .publishhouse .mini_input{
        display: inline-block;
        width: 100px;
    }
    .publishhouse .furnishings{
        display: inline-block;
    }
    .publishhouse .form_item{
        margin-left: 25px;
    }
    .publishhouse .el-input__inner{
        height: 30px;
        line-height: 30px;
    }
    .publishhouse .el-input__icon{
        line-height: 30px;
    }
    
   .publishhouse .upload_demo{
        border: 1px dashed #efefef;
        padding: 20px;
        width: 80%;
        margin-top: 10px;
        min-height: 150px;
        text-align: center;
    }
    .publishhouse .el-upload--picture-card{
        border: none;
        width: 80px;
        height: 32px;
        margin: 0 auto;
        margin-top: 30px;
    }
    .publishhouse .max_input{
        display: inline-block;
        width: 330px;
        margin-top: 10px;
    }
    .publishhouse .rent_demo,.self_demo{
        padding-left: 20px;
        margin-bottom: 10px;
    }
    .publishhouse .self_demo label{
        margin-right: 5px;
    }
    .publishhouse .rent_demo .radio_select{
        margin-left: 60px;
        margin-bottom: 15px;
    }
   .publishhouse .rent_demo .el-radio{
        margin-right: 20px;
    }
    .publishhouse .el-radio__label,.el-checkbox__label{
        padding-left: 3px;
    }
   .publishhouse .furnishings{
        padding-left: 77px;
        margin-top: -18px;
    }
   .publishhouse .furnishings .el-checkbox{
        margin-right: 0;
        width: 130px;
        margin-bottom: 5px;
    }
    .publishhouse .parking_select{
        display: inline-block;
        padding-left: 70px;
    }
    .publishhouse .parking_select .el-input__inner{
        height: 20px;
        padding: 0 5px;
    }
    
    .publishhouse .parking_select .el-input__icon{
        line-height: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/publishHouse/components/publishSecond.vue